module.exports = "/images/wm-team-ann-shadow.d11e724da345f04c5ac880b6e6566105.png";